import { render } from "./classifyTable.vue?vue&type=template&id=06400708&scoped=true"
import script from "./classifyTable.vue?vue&type=script&lang=js"
export * from "./classifyTable.vue?vue&type=script&lang=js"

import "./classifyTable.vue?vue&type=style&index=0&id=06400708&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06400708"]])

export default __exports__